import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IStartEnglishIqSessionV1Request } from './start-english-iq-session-v1-request';
import type { IStartEnglishIqSessionV1Response } from './start-english-iq-session-v1-response';
import { startEnglishIqSessionV1ResponseSchema } from './start-english-iq-session-v1-response';

export async function startEnglishIqSessionV1Api(
  body: IStartEnglishIqSessionV1Request,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IStartEnglishIqSessionV1Response>> {
  return postRequest<IStartEnglishIqSessionV1Response>({
    body,
    options,
    path: '/english-iq/session/v1',
    schema: startEnglishIqSessionV1ResponseSchema,
  });
}
